import React from 'react'
import { DatePicker} from 'antd'
import moment from 'moment';
import localeCN from 'antd/es/date-picker/locale/zh_CN';
import localeTH from 'antd/es/date-picker/locale/th_TH';
import localeEN from 'antd/es/date-picker/locale/en_US';

const DatePickerSelection = ({ onSelected, language }) => {
  const { RangePicker } = DatePicker

  const handleChange = (value) => {
    if(!value) {
      onSelected({startDate: '', endDate: ''})
    } else {
      const startDate = moment(value[0]).format('YYYY-MM-DD')
      const endDate = moment(value[1]).format('YYYY-MM-DD')
      onSelected({startDate, endDate})
    }
  }

  const switchLangDatepickerLang = () => {
    if (language === "en") {
        return localeEN
    } else if (language === "th") {
        return localeTH
    } else if (language === "cn") {
        return localeCN
    }
  }

  const handleDateFormat = () => {
    if(language === 'th') {
      return 'll'
    }else if(language === 'cn') {
      return 'DD MMM YYYY'
    }else{
      return 'MMM Do YY'
    }
  }

  return (
    <div>
      <RangePicker
       ranges={{
        Today: [moment(), moment()],
        }} 
        onChange={handleChange}
        format={handleDateFormat()}
        locale={switchLangDatepickerLang()} />
    </div>
  )
}

export default DatePickerSelection
